import api from '@/utils/api';

/**
 * Get all categories
 * @param {string} query - Query to filter categories
 * @returns {Promise}
 */
const getCategoriesApi = (query) => {
  const url = query ? `category?${query}` : 'category';
  return api.get(url);
};

export default getCategoriesApi;
